import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-step-email-reply",
  "use": "icon-step-email-reply-usage",
  "viewBox": "0 0 16 17",
  "content": "<symbol viewBox=\"0 0 16 17\" fill=\"none\" xmlns=\"http://www.w3.org/2000/svg\" id=\"icon-step-email-reply\">\n<path d=\"M15.2008 13.8478C15.2008 13.8478 13.4208 6.0622 6.40078 6.0622V2.875L0.800781 8.1334L6.40078 13.4854V9.9998C10.2112 9.999 13.2136 10.3366 15.2008 13.8478Z\" fill=\"#98A1B3\" />\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol